import { useHorizontalDragScroll } from '@/hooks/useHorizontalDragScroll';
import { cn } from '@/utils/cn';

interface SliderWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
}

export const SliderWrapper = ({ className, children, ...props }: SliderWrapperProps) => {
  const {
    scrollContainerRef,
    handlePointerDown,
    handlePointerMove,
    handlePointerUp,
    handlePointerCancel,
    handleClickCapture,
    handleDragStart,
  } = useHorizontalDragScroll();

  return (
    <div
      ref={scrollContainerRef}
      style={{ WebkitOverflowScrolling: 'touch' }}
      onPointerDown={handlePointerDown}
      onPointerMove={handlePointerMove}
      onPointerUp={handlePointerUp}
      onPointerCancel={handlePointerCancel}
      onClickCapture={handleClickCapture}
      onDragStart={handleDragStart}
      className={cn('overflow-x-auto overflow-y-hidden hide-scrollbar cursor-grab active:cursor-grabbing select-none', className)}
      {...props}
    >
      {children}
    </div>
  );
};
